import React from 'react';

function Grommet() {
  const grommetStyle = {
    width: '38.25px',
    height: '38.25px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #b8860b, #daa520, #b8860b)',
    border: '2px solid #8b6914',
    boxShadow: 'inset 0 2px 4px rgba(255,255,255,0.3), 0 2px 8px rgba(0,0,0,0.3)',
    position: 'relative',
  };

  const innerCircleStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '15.3px',
    height: '15.3px',
    borderRadius: '50%',
    background: 'var(--bg-default)',
    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.5)',
  };

  const lineStyle = {
    position: 'absolute',
    top: '50%',
    left: '-10px',
    transform: 'translateY(-50%) rotate(-5deg)',
    width: '35px',
    height: '2px',
    background: 'black',
    zIndex: 1,
  };

  return (
    <div style={grommetStyle}>
      <div style={innerCircleStyle}></div>
      <div style={lineStyle}></div>
    </div>
  );
}

export default Grommet;